import React from "react";
import { cn } from "@/lib/utils";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";

interface Props {
  selectedBusinessReport: BusinessReport | null;
  businessReport: BusinessReport;
  handleTemplateSelect: (businessReport: BusinessReport) => void;
}

export const BusinessReportRow: React.FC<Props> = ({
  handleTemplateSelect,
  businessReport,
  selectedBusinessReport,
}) => {
  const isSelected = selectedBusinessReport?.id === businessReport.id;

  return (
    <button
      type="button"
      title={businessReport.name}
      aria-current={isSelected ? "true" : undefined}
      className={cn(
        "w-full truncate rounded-md px-3 py-2 text-left text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-desert-sand-300",
        isSelected
          ? "bg-[#f1e2ce] font-semibold text-[#111b35]"
          : "font-medium text-gray-700 hover:bg-[#f7f2ec] hover:text-[#111b35]",
      )}
      onClick={() => handleTemplateSelect(businessReport)}
    >
      {businessReport.name}
    </button>
  );
};
